import React from 'react';
import { Toast, ToastBody } from 'reactstrap';

export default class ScribeNotificationRails extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      active: this.props.active,
    };
  }

  background() {
    return this.props.error ? '#fcecec' : '#fcf6eb';
  }

  text() {
    return this.props.error ? '#a94442' : '#8a6d3b';
  }

  border() {
    return this.props.error ? '#e13c3c' : '#e1a93a';
  }

  actionText() {
    return '#a94442';
  }

  static get colorSet() {
    return {
      error: {
        background: '#fcecec',
        text: '#a94442',
        border: '#e13c3c',
        actionText: '#a94442',
      },
      alert: {
        background: '#fcf6eb',
        text: '#8a6d3b',
        border: '#e1a93a',
        actionText: '#a94442',
      },
      notice: {
        background: 'white',
        text: 'black',
        border: '#6eafbe',
        actionText: 'black',
      },
      success: {
        background: '#e8f1e3',
        text: 'black',
        border: '#76ae5a',
        actionText: 'black',
      },
    };
  }

  colors() {
    const type = this.props.type;
    return ScribeNotificationRails.colorSet[type];
  }

  dismiss = () => {
    this.setState({ active: !this.state.active });
  }

  getTop() {
    let num = 6;
    if (this.props.index && this.props.index !== 0) {
      num = (4 * this.props.index) + 6;
    }
    return `${num.toString()}em`;
  }

  render() {
    const colors = ScribeNotificationRails.colorSet[this.props.type] || ScribeNotificationRails.colorSet.notice;
    return (
      <div
        className="position-fixed end-0 p-3"
        style={{
          zIndex: 11,
          top: this.getTop()
        }}
      >
        <Toast
          isOpen={this.state.active}
          style={{
            fontSize: '1.2rem',
            fontFamily: 'Alegreya Sans',
            backgroundColor: colors.background,
            color: colors.text,
            border: `solid 2px ${colors.border}`,
            bottom: 'inherit',
        }}>
            <ToastBody>{this.props.message} <button href="" className="btn-close float-end" onClick={this.dismiss}></button></ToastBody>
        </Toast>
      </div>
    );
  }
}
